"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.MultiDocumentAggregator = void 0;
var react_1 = require("@moopsyjs/react");
var toolkit_1 = require("@moopsyjs/toolkit");
var timingAsync = function (label, fn) { return __awaiter(void 0, void 0, void 0, function () {
    var start, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                start = Date.now();
                return [4 /*yield*/, fn()];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
function retrieveDocumentsFromPreload(forKey, cache) {
    var result = cache.getPreloaded("".concat(forKey, "/_list"));
    if (result != null) {
        var documents = result.map(function (itemKey) { return cache.getPreloaded("".concat(forKey, "/").concat(itemKey)); }).filter(function (d) { return d != null; });
        return documents;
    }
    return [];
}
function retrieveDocumentsFromCache(forKey, cache) {
    return __awaiter(this, void 0, void 0, function () {
        var result, documentPromises, documents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cache.get("".concat(forKey, "/_list"))];
                case 1:
                    result = _a.sent();
                    if (!(result != null)) return [3 /*break*/, 3];
                    documentPromises = result.map(function (itemKey) { return cache.get("".concat(forKey, "/").concat(itemKey)); });
                    return [4 /*yield*/, Promise.all(documentPromises)];
                case 2:
                    documents = (_a.sent()).filter(function (d) { return d != null; });
                    return [2 /*return*/, documents];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
var MultiDocumentAggregator = /** @class */ (function () {
    function MultiDocumentAggregator(client, options) {
        var _this = this;
        this._emitter = new toolkit_1.TypedEventEmitterV3();
        this._retryCount = 0;
        this._destroyed = false;
        this._refreshing = false;
        this._cacheRetrieved = false;
        this.destroy = function () {
            _this._destroyed = true;
            _this.client.off.transportStatusChange(_this._handleTransportStatusChange);
            _this._subscriptionListener.stop();
        };
        this._handleTransportStatusChange = function (status) {
            timingAsync('_handleTransportStatusChange', function () {
                if (status === react_1.TransportStatus.connected && status !== _this._transportStatus) {
                    void _this.refresh();
                }
                _this._transportStatus = status;
            });
        };
        this._ingest = function (incoming, dontCache, overwrite) {
            if (dontCache === void 0) { dontCache = false; }
            if (_this._destroyed)
                return;
            var current = overwrite === true ? [] : __spreadArray([], _this._current, true);
            var changedDocuments = [];
            var _loop_1 = function (item) {
                var key = _this._options.keyExtractorFn(item);
                var existingIndex = current.findIndex(function (i) { return _this._options.keyExtractorFn(i) === key; });
                if (existingIndex !== -1) {
                    if (_this._options.freshnessFn != null) {
                        if (_this._options.freshnessFn(current[existingIndex]) > _this._options.freshnessFn(item)) {
                            return "continue";
                        }
                    }
                    current[existingIndex] = item;
                }
                else {
                    current.push(item);
                }
                changedDocuments.push({
                    key: key,
                    document: item
                });
            };
            for (var _i = 0, incoming_1 = incoming; _i < incoming_1.length; _i++) {
                var item = incoming_1[_i];
                _loop_1(item);
            }
            if (dontCache !== true) {
                for (var _a = 0, changedDocuments_1 = changedDocuments; _a < changedDocuments_1.length; _a++) {
                    var changed = changedDocuments_1[_a];
                    void _this._options.cache.set("".concat(_this._options.key, "/").concat(changed.key), changed.document);
                }
                var list = _this._options.limit == null ? current.map(function (i) { return _this._options.keyExtractorFn(i); }) : current.sort(_this._options.limit.sort).slice(0, _this._options.limit.number).map(function (i) { return _this._options.keyExtractorFn(i); });
                void _this._options.cache.set("".concat(_this._options.key, "/_list"), list);
            }
            _this._current = current;
            _this._emitter.emit("changed", current);
        };
        this._remove = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                timingAsync('ingest', function () { return __awaiter(_this, void 0, void 0, function () {
                    var current, existingIndex;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this._destroyed)
                                    return [2 /*return*/];
                                current = __spreadArray([], this._current, true);
                                existingIndex = current.findIndex(function (i) { return _this._options.keyExtractorFn(i) === key; });
                                if (existingIndex !== -1) {
                                    current.splice(existingIndex, 1);
                                }
                                void this._options.cache.set("".concat(this._options.key, "/").concat(key), null);
                                return [4 /*yield*/, timingAsync('store list', function () { return __awaiter(_this, void 0, void 0, function () {
                                        var list;
                                        var _this = this;
                                        return __generator(this, function (_a) {
                                            list = this._options.limit == null ? current.map(function (i) { return _this._options.keyExtractorFn(i); }) : current.sort(this._options.limit.sort).slice(0, this._options.limit.number).map(function (i) { return _this._options.keyExtractorFn(i); });
                                            void this._options.cache.set("".concat(this._options.key, "/_list"), list);
                                            return [2 /*return*/];
                                        });
                                    }); })];
                            case 1:
                                _a.sent();
                                this._current = current;
                                this._emitter.emit("changed", current);
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        this.resolveQueryParams = function () { return __awaiter(_this, void 0, void 0, function () {
            var fn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fn = this._options.query.params;
                        if (!!this._cacheRetrieved) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._cachePromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, fn(this._current)];
                }
            });
        }); };
        this.refresh = function (isRetry) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                timingAsync('refresh', function () { return __awaiter(_this, void 0, void 0, function () {
                    var response, _a, _b, _c, mappedData, e_1, err;
                    var _this = this;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                if (this._refreshing || (isRetry === true && this._retryCount > 3))
                                    return [2 /*return*/];
                                this._refreshing = true; // TODO: TIMEOUT
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 6, 7, 8]);
                                _b = (_a = this._mutation).call;
                                if (!(typeof this._options.query.params === 'function')) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.resolveQueryParams()];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _c = this._options.query.params;
                                _d.label = 4;
                            case 4: return [4 /*yield*/, _b.apply(_a, [_c])];
                            case 5:
                                response = _d.sent();
                                this._retryCount = 0;
                                mappedData = this._options.query.mapperFn(response);
                                void this._ingest(mappedData, false, this._options.query.mode === 'overwrite');
                                return [3 /*break*/, 8];
                            case 6:
                                e_1 = _d.sent();
                                err = e_1;
                                if ('code' in err && err.code !== 429) {
                                    setTimeout(function () {
                                        _this.refresh(true);
                                    }, 750);
                                }
                                return [3 /*break*/, 8];
                            case 7:
                                this._refreshing = false;
                                return [7 /*endfinally*/];
                            case 8: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        this.listen = function (fn) {
            _this._emitter.on('changed', fn);
            return {
                stop: function () {
                    _this._emitter.off('changed', fn);
                }
            };
        };
        var start = Date.now();
        this.client = client;
        this._transportStatus = client.getTransportStatus();
        this._options = options;
        this._subscription = this.client.createPubSubSubscription({
            topic: options.subscription.topic,
            topicId: options.subscription.blueprint.TopicID,
            params: null
        });
        this._subscriptionListener = this._subscription.listen(function (doc) {
            if ('_remove' in doc) {
                void _this._remove(doc._remove);
            }
            else {
                void _this._ingest([doc], false);
            }
        });
        this._mutation = new react_1.MoopsyMutation(this.client, this._options.query.blueprint, { querySideEffects: [] });
        this.client.on.transportStatusChange(this._handleTransportStatusChange);
        this._current = retrieveDocumentsFromPreload(options.key, options.cache);
        this._cachePromise = (function () { return __awaiter(_this, void 0, void 0, function () {
            var documents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, retrieveDocumentsFromCache(options.key, options.cache)];
                    case 1:
                        documents = _a.sent();
                        return [4 /*yield*/, this._ingest(documents, false)];
                    case 2:
                        _a.sent();
                        this._cacheRetrieved = true;
                        return [2 /*return*/];
                }
            });
        }); })();
        if (this._transportStatus === react_1.TransportStatus.connected) {
            void this.refresh();
        }
    }
    return MultiDocumentAggregator;
}());
exports.MultiDocumentAggregator = MultiDocumentAggregator;
